import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { showErrors } from '../../modules/general';
import { apiFetch } from '../../modules/utility';
import { get as fuelContractGet } from '../../modules/inventory/fuelContract';

const apiBase = 'railcar';

const get = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.get`,
			params,
			dispatch,
			callback,
		});
	};
};

const mapStateToProps = (state, ownProps) => {
	const railcarId = _.get(ownProps, ['match', 'params', 'railcarId']);
	const railcar = _.get(state.maps, ['railcar', railcarId]);
	const fuelContract = railcar
		? _.get(state.maps, ['fuelContract', railcar.fuelContractId])
		: undefined;

	return {
		railcarId,
		railcar,
		fuelContract,
		terminalMap: state.maps.terminal,
		supplierMap: state.maps.supplier,
	};
};

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			railcarGet: get,
			fuelContractGet,
			showErrors,
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps);
